import React from "react";

export default function RgaWordmark({ className = "", compact = false }) {
  return (
    <div className={`flex flex-col items-center text-center ${className}`}>
      {/* Vector Laurel Wreath & Scales of Justice */}
      <svg
        className={compact ? "h-11 w-11" : "h-16 w-16"}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Wreath Left */}
        <path
          d="M32,32 C23,42 23,62 36,72 C38,74 40,75 42,75"
          stroke="#93b4d4"
          strokeWidth="3.5"
          strokeLinecap="round"
          fill="none"
        />
        {/* Wreath Leaves Left */}
        <path d="M26,38 C23,36 22,39 25,41" stroke="#93b4d4" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M23,48 C19,47 19,50 22,52" stroke="#93b4d4" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M24,58 C20,59 21,62 24,63" stroke="#93b4d4" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M29,67 C26,70 28,72 31,71" stroke="#93b4d4" strokeWidth="2.5" strokeLinecap="round" />

        {/* Wreath Right */}
        <path
          d="M68,32 C77,42 77,62 64,72 C62,74 60,75 58,75"
          stroke="#93b4d4"
          strokeWidth="3.5"
          strokeLinecap="round"
          fill="none"
        />
        {/* Wreath Leaves Right */}
        <path d="M74,38 C77,36 78,39 75,41" stroke="#93b4d4" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M77,48 C81,47 81,50 78,52" stroke="#93b4d4" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M76,58 C80,59 79,62 76,63" stroke="#93b4d4" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M71,67 C74,70 72,72 69,71" stroke="#93b4d4" strokeWidth="2.5" strokeLinecap="round" />

        {/* Scales Pillars */}
        <line x1="50" y1="22" x2="50" y2="76" stroke="#7297c1" strokeWidth="3" strokeLinecap="round" />
        <path d="M46,26 L50,20 L54,26 Z" fill="#7297c1" />
        <line x1="40" y1="76" x2="60" y2="76" stroke="#7297c1" strokeWidth="3.5" strokeLinecap="round" />
        
        {/* Balance Beam */}
        <line x1="30" y1="36" x2="70" y2="36" stroke="#7297c1" strokeWidth="3" strokeLinecap="round" />
        
        {/* Left Hanging Pan */}
        <line x1="30" y1="36" x2="24" y2="54" stroke="#7297c1" strokeWidth="1.5" />
        <line x1="30" y1="36" x2="36" y2="54" stroke="#7297c1" strokeWidth="1.5" />
        <path d="M22,54 L38,54 C38,59 22,59 22,54 Z" fill="#7297c1" stroke="#7297c1" strokeWidth="1" />
        
        {/* Right Hanging Pan */}
        <line x1="70" y1="36" x2="64" y2="54" stroke="#7297c1" strokeWidth="1.5" />
        <line x1="70" y1="36" x2="76" y2="54" stroke="#7297c1" strokeWidth="1.5" />
        <path d="M62,54 L78,54 C78,59 62,59 62,54 Z" fill="#7297c1" stroke="#7297c1" strokeWidth="1" />
      </svg>
      <span
        style={{ fontFamily: "'Georgia', 'Playfair Display', serif" }}
        className={`font-semibold italic text-[#5c7a9e] tracking-tight mt-1 whitespace-nowrap ${
          compact ? "text-[14px]" : "text-[18px]"
        }`}
      >
        Robyn Greensill & Associates
      </span>
    </div>
  );
}
